import './Spinner.scss'

const Spinner = () => (
  <div className="spinner-wrapper">
    <div className="spinner" />
  </div>
)

export default Spinner
